import type { Questao, QuestaoTipo, QuestaoDificuldade, UpsertQuestaoCommand } from '@/domain/model/Questao';
import type { Page } from '@/domain/model/Page';
import type { QuestaoGateway } from '@/application/port/out/QuestaoGateway';
import type {
  ListQuestoesUseCase, GetQuestaoUseCase, CreateQuestaoUseCase,
  UpdateQuestaoUseCase, DeleteQuestaoUseCase,
} from '@/application/port/in/QuestaoUseCase';

export class ListQuestoes implements ListQuestoesUseCase {
  constructor(private readonly g: QuestaoGateway) {}
  execute(p: { tipo?: QuestaoTipo; dificuldade?: QuestaoDificuldade; page?: number; size?: number }): Promise<Page<Questao>> {
    return this.g.list(p);
  }
}
export class GetQuestao implements GetQuestaoUseCase {
  constructor(private readonly g: QuestaoGateway) {}
  execute(id: string): Promise<Questao> { return this.g.get(id); }
}
export class CreateQuestao implements CreateQuestaoUseCase {
  constructor(private readonly g: QuestaoGateway) {}
  execute(c: UpsertQuestaoCommand): Promise<Questao> { return this.g.create(c); }
}
export class UpdateQuestao implements UpdateQuestaoUseCase {
  constructor(private readonly g: QuestaoGateway) {}
  execute(id: string, c: UpsertQuestaoCommand): Promise<Questao> { return this.g.update(id, c); }
}
export class DeleteQuestao implements DeleteQuestaoUseCase {
  constructor(private readonly g: QuestaoGateway) {}
  execute(id: string): Promise<void> { return this.g.delete(id); }
}
